const LogisticOperators = () => import('@/modules/logisticOperators');

export default [
  {
    path: '/franquia/config/operadores-logisticos',
    name: 'list-logistic-operators',
    component: LogisticOperators,
    props: true,
    meta: {
      showSidebar: false,
      navbarTitle: 'Configurações',
      isAvaliableInMenu: false, // PDME-119 Ocultado no menu
      menuData: {
        title: 'Listar operadores logísticos',
        id: 'logisticOperatorSidebar',
      },
    },
  },
  {
    path: '/franquia/config/operadores-logisticos/criar',
    name: 'create-logistic-operator',
    component: LogisticOperators,
    props: true,
    meta: {
      showSidebar: false,
      navbarTitle: 'Configurações',
      isAvaliableInMenu: false, // PDME-119 Ocultado no menu
      menuData: {
        title: 'Cadastrar operador logístico',
        id: 'createLogisticOperatorSidebar',
      },
    },
  },
];
